(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discontinued-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('discontinued-notice')) {
    class DiscontinuedNotice extends HTMLElement {
      connectedCallback() {
        this.messages = this.readMessages(this);
        this.section = this.closest('.shopify-section, dialog');
        this.section?.addEventListener('variant:update', this.onVariantUpdate);
      }

      disconnectedCallback() {
        this.section?.removeEventListener('variant:update', this.onVariantUpdate);
      }

      readMessages(element) {
        try {
          return JSON.parse(element.querySelector('script[type="application/json"]')?.textContent || '{}');
        } catch {
          return {};
        }
      }

      onVariantUpdate = (event) => {
        const { resource, data } = event.detail || {};
        if (!resource?.id) return;

        if (data?.newProduct) {
          // Combined listing swapped to another product: take its messages from the new HTML
          const fresh = data.html?.querySelector?.('discontinued-notice');
          this.messages = fresh ? this.readMessages(fresh) : {};
          this.dataset.productId = String(data.newProduct.id);
        } else if (data?.productId && String(data.productId) !== this.dataset.productId) {
          return;
        }

        const element = this.querySelector('.discontinued-message');
        if (!element) return;

        const message = this.messages[resource.id] || '';
        element.innerHTML = message;
        element.hidden = message === '';
      };
    }

    customElements.define('discontinued-notice', DiscontinuedNotice);
  }
  } catch(e) { console.error(e); }
})();

})();
